import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';

import { actions as reduxAction } from '../simCardsIoT/reducers';
import SimCardsTable from '../simCardsIoT/components/SimCardsTable';
import OrderNewSimcard from '../../modals/orderNewSimcard/OrderNewSimcard';
import ActivateSimcard from '../simCardsIoT/components/ActivateSimcard';
import mapAccounts from '../simCardsIoT/actions/mapAccounts';
import SelectAccount from '../simCardsIoT/components/SelectAccount';
import ActivationSummary from '../simCardsIoT/components/ActivationSummary';

const MobileBroadbandSubscriptions = ({
  resetSimCards,
  clientId,
  mapAccounts
}) => {
  useEffect(() => {
    mapAccounts({
      clientId
    });
    return resetSimCards;
    // eslint-disable-next-line
  }, [clientId]);

  return (
    <div>
      <SelectAccount />
      <SimCardsTable category="MBB" />
      <OrderNewSimcard />
      <ActivateSimcard category="MBB" />
      <ActivationSummary />
    </div>
  );
};

const mapStatesToProps = ({ selectClient }) => {
  return {
    clientId: selectClient.selectedClient?.id
  };
};

const mapDispatchToProps = {
  resetSimCards: reduxAction.resetSimCards,
  mapAccounts
};

export default flowRight(connect(mapStatesToProps, mapDispatchToProps))(
  MobileBroadbandSubscriptions
);
